@if (content(); as content) {
  <div
    [ngClass]="isGrid() ? 'aspect-square' : ''"
    class="rounded-xl border flex flex-col overflow-hidden w-full"
  >
    <div
      [ngClass]="isGrid() ? 'hidden' : ''"
      class="px-5 py-3 flex justify-between items-center"
    >
      <div class="flex gap-3 items-center">
        <app-profile-image
          [src]="
            content.writerProfileImageUrl ||
            'https://kr1-api-object-storage.nhncloudservice.com/v1/AUTH_2355fbddd74e499f89b6640b98832b2c/file-storage/logo.svg'
          "
        />
        <div class="flex gap-3">
          <div class="flex gap-1 items-center">
            <p>{{ content.writer ? content.writer : '말이랑 공식' }}</p>
            @if (!content.writer) {
              <app-icon
                name="solar:verified-check-bold"
                size="sm"
                class="text-primary"
              />
            }
          </div>
          @if (content.writerDescription; as description) {
            <p class="text-gray-600 text-sm">{{ description }}</p>
          }
        </div>
      </div>
      @if (content.isPinned) {
        <app-icon name="ic:baseline-push-pin" class="text-gray-500" />
      }
    </div>

    <div [ngClass]="isGrid() ? 'aspect-square' : ''">
      <app-content-images
        [imageUrls]="content.imageUrls"
        class="w-full"
        [hiddenIndex]="isGrid()"
      />
    </div>

    <div
      [ngClass]="isGrid() ? 'hidden' : ''"
      class="flex flex-col gap-3 p-5 size-full"
    >
      <div class="flex w-full justify-between items-center">
        <div class="px-2 py-1 rounded-lg bg-gray-100 text-gray-500 text-xs">
          {{ content.category?.name || content.category }}
        </div>
        <div class="flex gap-3 items-center">
          <app-content-favorite
            (favorite)="handleFavorite()"
            [isFavorite]="isFavorite()"
          />
          <app-content-share [title]="content.title" />
        </div>
      </div>
      <p
        class="text-gray-800 font-semibold"
        [ngClass]="isGrid() ? 'overflow-hidden line-clamp-1' : ''"
      >
        {{ content.title }}
      </p>
      <p
        class="text-gray-600 max-h-[3ch] line-clamp-1 overflow-hidden"
        [innerHTML]="content.content"
      ></p>
      <div class="flex w-full items-center justify-between">
        <p class="text-gray-600 text-sm">
          {{ content.eventAt | date: 'y.MM.dd' }}
        </p>
        <p class="text-gray-600 text-sm">
          조회수 {{ content.viewCount | number }}
        </p>
      </div>
    </div>
  </div>
}
